import React, { useRef } from "react";
import "../../../Assets/Css/EmpProject.scss";
import Table from "../../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { customStyle } from '../../../Components/Style'
import { useState } from "react";
import { connect } from "react-redux";
import Select from 'react-select'
import qs from "query-string";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import CustomCalendar from '../../../Components/CustomCalendar';
import AddEmpProjectModal from './EmpProjectAdd';
import { getprojects } from "../../../Services/Project/action";
import { deleteRecord } from "../../../Services/Delete/action";
import moment from "moment";
import ModulesList from "../../../Assets/ModulesLiist";
import FeaturesList from "../../../Assets/FeaturesList";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../Lib/RoleWiseFeatureWrapper";
import { exportData } from "../../../Lib/exportData";
import Skeleton from "react-loading-skeleton";


const EmpProject = (props) => {
    const location = useLocation();
    const [checked, setChecked] = useState(false);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const fileInputRef = useRef(null);
    const modalRef = useRef(null);

    const navigate = useNavigate();

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.Delete,
    });
    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.Update,
    });

    const openModal = () => setModalVisible(true);
    const closeModal = () => setModalVisible(false);

    const header = [
        { field: 'checkbox' },
        { field: "Project Code" },
        { field: "Project" },
        { field: "Client" },
        { field: "Status" },
        { field: "Action" },
    ];

    const ProjectStatus = [
        { value: "All", label: "All" },
        { value: "Not Started", label: "Not Started" },
        { value: "In Progress", label: "In Progress" },
        { value: "On Hold", label: "On Hold" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Finished", label: "Finished" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getprojects();
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    useEffect(() => {
        if (props?.project) {
            setInData(
                props?.project
                    ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    ?.map((project) => ({
                    checkbox: {
                        value: project?.id,
                        type: "checkbox",
                    },
                    "Project Code": {
                        value: project?.code,
                        type: "text",
                    },

                    Project: {
                        value: project?.name,
                        type: "text",
                    },
                    "Status": {
                        value: project?.status,
                        type: 'status_type'
                    },
                    Client: {
                        value: project?.client?.name,
                        type: "text",
                    },
                    Action: {
                        value: "/project/employeeproject/edit",
                        value2: `/project/employeeproject/view/${project?.id}/overview`,
                        value3: project?.id,
                        type: "action",
                    },
                    allData: {
                        ...project
                    },
                    "Start Date": {
                        value: project?.start_date
                    },
                    "End Date": {
                        value: project?.end_date
                    }
                }))
            );
        } else {
            setInData([]);
        }
    }, [props?.project]);


    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleFileChange = (event) => {
        const f = event.target.files[0];
        setSelectedFile(f);
        if (f) {
            setFileName(f.name);
        } else {
            setFileName('');
        }
    }

    const handleImportClick = async (event) => {
        try {
            setLoading(true);

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const csvData = e.target.result;
                    await props.importPurchaseInvoiceCSV(selectedFile, csvData);
                    setLoading(false);
                    setFileName('');
                    setSelectedFile(null);
                    fileInputRef.current.value = null;
                } catch (error) {
                    setHasError(true);
                    console.error('Error importing purchse invoices:', error);
                    toast.error('Error importing purchse invoices:', error.message);
                    setLoading(false)

                }
            };

            reader.readAsText(selectedFile);

        } catch (error) {
            setHasError(true);
            console.error('Error importing transactions:', error);
            toast.error('Error importing transactions:', error.message);
            setLoading(false)
        }
    };

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportLoading(true);
                await handleXlsxDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox', 'Action'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = inData
            .filter(item => Ids.includes(item.allData?.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (key === 'Assigned To' && Array.isArray(cell.value)) {
                        newRow[label] = cell.value.map(person => person.name).join(', ');
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });

        exportData({
            data: selectedData,
            columns,
            fileName: 'Projec_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const handleAddClick = () => {
        navigate('/project/add');
    }

    const initialState = {
        projectstatus: null,
        date: null,
        search: ""
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);

    const applyFilters = ({ status, startDate, endDate, search }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((project) => {
            let matchesStatus = true;
            let matchesSearch = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(project?.["Start Date"]?.value).startOf('day');
                const itemDueDate = project?.["End Date"]?.value
                    ? moment(project?.["End Date"]?.value).startOf('day')
                    : itemStartDate;

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
            }

            if (status && status?.value !== "All") {
                matchesStatus = project?.Status?.value?.toLowerCase() == status?.value?.toLowerCase();
            }

            if (search) {
                matchesSearch = project?.Project?.value?.toLowerCase()?.includes(search?.toLowerCase())
            }
            return matchesStatus && matchesSearch && matchesDate;
        });
        setFilteredData(filtered);
    };


    const handleSelectStatusChange = (val) => {
        setClientData((prevVal) => ({
            ...prevVal,
            projectstatus: val,
        }));
        applyFilters({ status: val, startDate: filteredStartDate, endDate: filteredEndDate, search: clientData?.search });
    };

    const handleClear = () => {
        setClientData({
            projectstatus: null,
            date: null,
            search: ''
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }
    return (
        <div>
            <div className="empProject-main">
                <div className="page-title">
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={200} height={40} />
                        ) : (
                            <h4>Project</h4>
                        )
                    }
                    <div>
                        {
                            props.loading ? (
                                <Skeleton className="badge rounded-pill" width={50} height={40} />
                            ) : (
                                <RoleWiseFeatureWrapper
                                    modules={props?.modules}
                                    features={props?.features}
                                    user={props?.user}
                                    ModuleName={ModulesList.Project}
                                    Featur_Name={FeaturesList.Create}>

                                    <button className="custom-empProject-btn" disabled={props.loading} onClick={() => navigate('/project/employeeproject/add')}>
                                        {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" size="sm" /> : "Add Project"}
                                    </button>
                                </RoleWiseFeatureWrapper>
                            )
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-3">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <Select
                                        options={ProjectStatus}
                                        styles={{
                                            ...customStyle,
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 2,
                                            }),
                                        }}
                                        value={clientData.projectstatus}
                                        placeholder="All"
                                        onChange={(val) => {
                                            handleSelectStatusChange(val);
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: "#5757fe",
                                                primary: "#5757fe",
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-4">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <CustomCalendar
                                        inData={inData}
                                        setFilteredData={setFilteredData}
                                        applyFilters={(params) => { applyFilters(params) }}
                                        startDate={filteredStartDate}
                                        endDate={filteredEndDate}
                                        setStartDate={setFilteredStartDate}
                                        setEndDate={setFilteredEndDate} />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-4">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="input-css"
                                        name='projectname'
                                        disabled={props.loading}
                                        placeholder="Search"
                                        value={clientData?.search}
                                        onChange={(e) => {
                                            setClientData((preVal) => ({
                                                ...preVal,
                                                search: e.target.value
                                            }));
                                            applyFilters({ status: clientData?.projectstatus, startDate: filteredStartDate, endDate: filteredEndDate, search: e.target.value })
                                        }}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-1">
                        {(clientData?.projectstatus || filteredData?.length > 0 || dateStatus || clientData?.search) && (
                            props.loading ? (
                                <Skeleton className="badge rounded-pill" width={100} height={40} />
                            ) : (
                                <button
                                    className="export-btn"
                                    disabled={props.loading}
                                    onClick={handleClear}
                                >
                                    Clear
                                </button>
                            )
                        )}
                    </div>
                </div>



                <div className="invoice-table-part">
                    {console.log(filteredData, clientData?.projectstatus)}
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" count={5} width="100%" height={40} />
                        ) : (
                            <Table
                                header={header}
                                data={(clientData?.projectstatus || dateStatus || clientData?.search) ? filteredData : inData}
                                footer={footer}
                                count={count}
                                records={count}
                                loading={props.loading}
                                deleteRecord={props?.deleteRecord}
                                showIsDelete={canDelete}
                                showIsView={canView}
                                showIsEdit={canEdit}
                                totalSelectedIds={totalSelectedIds}
                                handleChange={handleChange}
                            />
                        )
                    }
                </div>
                <AddEmpProjectModal isModalVisible={isModalVisible} closeModal={closeModal} />
            </div>

            {/* <div className="invoice-table-part">
                {console.log(filteredData, clientData?.projectstatus)}
                <Table
                    header={header}
                    data={(clientData?.projectstatus || dateStatus || clientData?.search) ? filteredData : inData}
                    footer={footer}
                    count={count}
                    records={count}
                    loading={props.loading}
                    deleteRecord={props?.deleteRecord}
                    showIsDelete={canDelete}
                    showIsView={canView}
                    showIsEdit={canEdit}
                    totalSelectedIds={totalSelectedIds}
                    handleChange={handleChange}
                />
            </div>
            <AddEmpProjectModal isModalVisible={isModalVisible} closeModal={closeModal} /> */}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.projectReducer.loading,
        project: state.projectReducer.project,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getprojects: () => {
            dispatch(getprojects());
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getprojects());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProject);
